import OspreyGetSummaryReports from './get-summary-reports'
import OspreyGetAudiences from './get-audiences'
import OspreyGetMatchedRo from './get-matched-ro'

export default class SummaryReports {

    getSummaryReports(...args) {
        return new OspreyGetSummaryReports(...args)
    }

    getAudiences(...args) {
        return new OspreyGetAudiences(...args)
    }

    getMatchedRepairOrders(...args) {
        return new OspreyGetMatchedRo(...args)
    }
}



// WEBPACK FOOTER //
// src/actions/osprey-api/summary-reports/index.js